/* eslint no-var: 0 */
var main = require('./dist/commonjs/index.js').default;

module.exports = main;
module.exports.default = main;



//////////////////
// WEBPACK FOOTER
// ./~/i18next-xhr-backend/index.js
// module id = 8369
// module chunks = 2